import { Injectable } from '@angular/core';
import {Observable} from 'rxjs';
import { Organisation } from '../../interfaces/core/organisation';
import {HttpService} from './http.service';
import {environment} from '../../../environments/environment';
import {map} from 'rxjs/operators';
import {OrganisationFactory} from '../../factories/core/organisation-factory';
import {StorageService} from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class OrganisationsService {

  private static _storageKey: string = 'organisation';
  private static _organisation: Organisation = null;

  /**
   *
   * @param storageService
   * @param httpService
   */
  constructor(private storageService: StorageService,
              private httpService: HttpService) { }

  /**
   *
   */
  public async init(): Promise<void> {
    const organisation = await this.storageService.getItem(OrganisationsService._storageKey);
    if(organisation) {
      OrganisationsService._organisation = organisation;
    }
  }

  /**
   *
   */
  public static get storageKey(): string {
    return OrganisationsService._storageKey;
  }

  /**
   *
   */
  public static async setOrganisation(organisation: Organisation): Promise<void> {
    await StorageService.setItem(OrganisationsService._storageKey, organisation);
    OrganisationsService._organisation = organisation;
  }

  /**
   *
   */
  public static getOrganisation(): Organisation {
    return OrganisationsService._organisation;
  }


  /**
   *
   */
  public static async removeOrganisation(): Promise<void> {
    await StorageService.removeItem(OrganisationsService._storageKey);
    this._organisation = null;
  }


  /**
   *
   */
  public loadOrganisations(): Observable<Organisation[]> {
    return this.httpService
      .get<any[]>(environment.organisationsUrl + '?app_key=' + environment.appKey)
      .pipe(map((_organisations) => OrganisationFactory.fromArray(_organisations)));
  }

}
